<template>
  <div
    :class="[
      'zg-grid',
      `zg-grid--${columns}-columns`,
      `zg-grid--${mColumns}-columns-m`,
      `zg-grid--${lColumns}-columns-l`,
      `zg-grid--${gap}-gap`,{
        'zg-grid--inline': inline,
      }]"
  >
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'ZgGrid',
    props: {
      /**
       * The number of columns the grid should be divided into
       */
      columns: {
        type: Number,
        default: 1,
        validator: value => Number.isInteger(value) && value <= 12 && value >= 1
      },
      /**
       * The number of columns on medium devices
       */
      mColumns: {
        type: Number,
        default: 2,
        validator: value => Number.isInteger(value) && value <= 12 && value >= 1
      },
      /**
       * The number of columns on large devices
       */
      lColumns: {
        type: Number,
        default: 3,
        validator: value => Number.isInteger(value) && value <= 12 && value >= 1
      },
      /**
       * The gap between items within the grid
       */
      gap: {
        type: String,
        required: false,
        default: 'base',
        validator: value => ['xsmall', 'small', 'base', 'medium', 'large', 'double']
      },
      inline: {
        type: Boolean,
        required: false,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  $gaps: xsmall, small, base, medium, large, double;

  .zg-grid {
    display: grid;

    @for $column from 1 through 12 {
      &--#{$column}-columns {
        grid-template-columns: repeat($column, 1fr);
      }

      &--#{$column}-columns-m {
        @include mq(medium) {
          grid-template-columns: repeat($column, 1fr);
        }
      }

      &--#{$column}-columns-l {
        @include mq(large) {
          grid-template-columns: repeat($column, 1fr);
        }
      }
    }

    @each $gap in $gaps {
      &--#{$gap}-gap {
        grid-gap: rhythm($gap);
      }
    }

    &--inline {
      display: inline-grid;
    }
  }
</style>
